var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-phone-number-input',_vm._b({ref:"phoneInput",attrs:{"required":_vm.required},on:{"input":_vm.onInput,"validate":_vm.onValidate,"country-changed":_vm.onCountryChange}},'vuetify-phone-number-input',_vm.bindProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }